import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Filtering',
  content: `
Pliable allows you to define rules to determine which records come through from your data source. You can set up filters in the **Data Cleaning Wizard**.

On the top right of your selected column, click on **Filter**. This will open the Edit Filters screen which allows you to add different conditions to columns.

# Conditions

If you click **Add Condition**, you can select a new column and condition. If you want to only allow records that match all of the conditions, keep **Match ALL** on, otherwise click to **Match ANY**.

After adding your conditions, click on **Test Filters** to display the resulting filtered data.
`,
};

export default doc;
